/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_isempty.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns true if the supplied geometry is empty.
 * An empty geometry is one that has no points, such as an empty geometry collection or an empty linestring.
 *
 * @example
 * ROW point = TO_GEOPOINT("POINT(1.0 2.0)"),
 *     empty_line = TO_GEOSHAPE("LINESTRING EMPTY"),
 *     empty_polygon = TO_GEOSHAPE("POLYGON EMPTY")
 * | EVAL pt_empty = ST_ISEMPTY(point),
 *        line_empty = ST_ISEMPTY(empty_line),
 *        polygon_empty = ST_ISEMPTY(empty_polygon)
 * | KEEP pt_empty, line_empty, polygon_empty
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'st_isempty',
  signatures: [
    {
      params: [
        {
          name: 'geometry',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'geometry',
          type: 'cartesian_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'geometry',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'geometry',
          type: 'geo_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'boolean',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
